import e from "./extends3.mjs";
import c from "./objectWithoutPropertiesLoose3.mjs";
import * as T from "react";
import { PickersPopper as eo } from "./PickersPopper.mjs";
import { useUtils as to } from "./useUtils.mjs";
import { jsx as r, jsxs as no } from "react/jsx-runtime";
import ro from "./useId.mjs";
import { usePicker as lo } from "./usePicker.mjs";
import so from "./InputAdornment.mjs";
import { useSlotProps as m } from "./useSlotProps.mjs";
import io from "./IconButton.mjs";
import { PickersLayout as po } from "./PickersLayout.mjs";
import ao from "./useForkRef.mjs";
import { LocalizationProvider as uo } from "./LocalizationProvider.mjs";
const co = ["props", "getOpenDialogAriaText"], mo = ["ownerState"], Po = ["ownerState"], Bo = (P) => {
  var f, k, I, b, x;
  let {
    props: n,
    getOpenDialogAriaText: $
  } = P, g = c(P, co);
  const {
    slots: t,
    slotProps: o,
    className: O,
    sx: V,
    format: D,
    formatDensity: L,
    timezone: U,
    name: j,
    label: S,
    inputRef: C,
    readOnly: y,
    disabled: R,
    autoFocus: z,
    localeText: M,
    reduceAnimations: E
  } = n, H = to(), h = T.useRef(null), F = T.useRef(null), i = ro(), v = (f = o == null || (k = o.toolbar) == null ? void 0 : k.hidden) != null ? f : !1, {
    open: p,
    actions: a,
    hasUIView: N,
    layoutProps: W,
    renderCurrentView: q,
    shouldRestoreFocus: G,
    fieldProps: A
  } = lo(e({}, g, {
    props: n,
    inputRef: h,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), _ = (I = t.inputAdornment) != null ? I : so, J = m({
    elementType: _,
    externalSlotProps: o?.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: n
  }), u = c(J, mo), w = (b = t.openPickerButton) != null ? b : io, K = m({
    elementType: w,
    externalSlotProps: o?.openPickerButton,
    additionalProps: {
      disabled: R || y,
      onClick: p ? a.onClose : a.onOpen,
      "aria-label": $(A.value, H),
      edge: u.position
    },
    ownerState: n
  }), Q = c(K, Po), X = t.openPickerIcon, B = t.field, l = m({
    elementType: B,
    externalSlotProps: o?.field,
    additionalProps: e({}, A, v && {
      id: i
    }, {
      readOnly: y,
      disabled: R,
      className: O,
      sx: V,
      format: D,
      formatDensity: L,
      timezone: U,
      label: S,
      name: j,
      autoFocus: z && !n.open,
      focused: p ? !0 : void 0
    }),
    ownerState: n
  });
  N && (l.InputProps = e({}, l.InputProps, {
    ref: F,
    [`${u.position}Adornment`]: /* @__PURE__ */ r(_, e({}, u, {
      children: /* @__PURE__ */ r(w, e({}, Q, {
        children: /* @__PURE__ */ r(X, e({}, o?.openPickerIcon))
      }))
    }))
  }));
  const Y = e({
    textField: t.textField,
    clearIcon: t.clearIcon,
    clearButton: t.clearButton
  }, l.slots), Z = (x = t.layout) != null ? x : po, oo = ao(h, l.inputRef, C);
  let d = i;
  v && (S ? d = `${i}-label` : d = void 0);
  const s = e({}, o, {
    toolbar: e({}, o?.toolbar, {
      titleId: i
    }),
    popper: e({
      "aria-labelledby": d
    }, o?.popper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ no(uo, {
      localeText: M,
      children: [/* @__PURE__ */ r(B, e({}, l, {
        slots: Y,
        slotProps: s,
        inputRef: oo
      })), /* @__PURE__ */ r(eo, e({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: F.current
      }, a, {
        open: p,
        slots: t,
        slotProps: s,
        shouldRestoreFocus: G,
        reduceAnimations: E,
        children: /* @__PURE__ */ r(Z, e({}, W, s?.layout, {
          slots: t,
          slotProps: s,
          children: q()
        }))
      }))]
    })
  };
};
export {
  Bo as useDesktopPicker
};
//# sourceMappingURL=useDesktopPicker.mjs.map
